import CourseCommunications from '../components/course-communication';
export default class CourseCommunicationsReactCtrl {
  /* @ngInject */
  constructor($scope) {
    $scope.CourseCommunications = CourseCommunications;
  }
}
